import React, { useState, useEffect } from "react";
import {
  AiFillCloseCircle,
  AiFillRightCircle,
  AiFillLeftCircle,
  AiFillCamera,
  AiFillVideoCamera,
} from "react-icons/ai";
import "./gallery.css";
import { server } from "../../common";  // <<--- common.js import कर

const Gallery = () => {
  document.title = "Gallery";

  const [images, setImages] = useState([]);
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);
  const [activeTab, setActiveTab] = useState("photos"); // 'photos' or 'videos'
  console.log(filteredImages.image,"filteredImagesfilteredImagesfilteredImagesfilteredImages");

  const [slideNumber, setSlideNumber] = useState(0);
  const [openModal, setOpenModal] = useState(false);

  // Function to extract YouTube video ID from URL
  const getYouTubeVideoId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  // fetch images from backend
  const fetchGallery = async () => {
    try {
      const res = await server.get("gallery/getallgallery"); 
      setImages(res.data);
      setFilteredImages(res.data);
    } catch (err) {
      console.error("Error fetching gallery:", err);
    }
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  // Filter by type (photos/videos)
  useEffect(() => {
    if (activeTab === "photos") {
      setFilteredImages(images.filter((item) => item.type === "photo" || !item.type));
    } else {
      setFilteredImages(images.filter((item) => item.type === "video"));
    }
  }, [activeTab, images]);

  //open modal
  const handleOpenModal = (index) => {
    setSlideNumber(index);
    setOpenModal(true);
  };

  // close modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  //left slide
  const preSlide = () => {
    slideNumber === 0
      ? setSlideNumber(filteredImages.length - 1)
      : setSlideNumber(slideNumber - 1);
  };

  //right slide
  const nextSlide = () => {
    slideNumber + 1 === filteredImages.length
      ? setSlideNumber(0)
      : setSlideNumber(slideNumber + 1);
  };

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="heading my-5">
              <h2>Gallery</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="gallery-tabs-wrapper">
              <div className="gallery-tabs-container">
                <button
                  className={`gallery-tab ${activeTab === "photos" ? "active" : ""}`}
                  onClick={() => setActiveTab("photos")}
                >
                  <AiFillCamera className="tab-icon" />
                  <span className="tab-text">Photos</span>
                </button>
                <button
                  className={`gallery-tab ${activeTab === "videos" ? "active" : ""}`}
                  onClick={() => setActiveTab("videos")}
                >
                  <AiFillVideoCamera className="tab-icon" />
                  <span className="tab-text">Videos</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Photos */}
      {openModal && filteredImages.length > 0 && activeTab === "photos" && (
        <div className="sliderWrap1">
          <AiFillCloseCircle className="btnclose" onClick={handleCloseModal} />
          <AiFillLeftCircle className="btnleft" onClick={preSlide} />
          <AiFillRightCircle className="btnright" onClick={nextSlide} />
          <div className="fullScreenImage1">
            <img src={filteredImages[slideNumber].image} alt="" />
            <p className="text-white">{filteredImages[slideNumber].title}</p>
          </div>
        </div>
      )}

      {/* Photos Gallery */}
      {activeTab === "photos" && (
        <div className="gallery-btn text-center">
          <div className="row">
            <div className="galleryWrap1 mt-2">
              {filteredImages.map((slide, index) => (
                <div
                  className="single1"
                  key={slide.id}
                  onClick={() => handleOpenModal(index)}
                >
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="border border-2 card-img-top"
                    height={200}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Videos Gallery */}
      {activeTab === "videos" && (
        <div className="container">
          <div className="row g-4 mt-2">
            {filteredImages.map((video) => {
              const videoId = getYouTubeVideoId(video.video_url);
              if (!videoId) return null;
              
              return (
                <div key={video.id} className="col-md-6">
                  <div className="card h-100 shadow-sm">
                    <div className="card-body p-0">
                      <div className="ratio ratio-16x9">
                        <iframe
                          src={`https://www.youtube.com/embed/${videoId}`}
                          title={video.title}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                        ></iframe>
                      </div>
                      <div className="p-3">
                        <h5 className="card-title">{video.title}</h5>
                        {video.description && (
                          <p className="card-text">{video.description}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;